import Classnames from 'classnames'
import { Spinner } from 'baseui/spinner'

const Button = ({
  text,
  onClick,
  className,
  icon,
  isLoading,
  iconColor,
  size,
  theme,
  disabled,
  block,
  domId,
}) => {
  return (
    <div
      onClick={() => {
        if (isLoading) {
          // loading
        } else if (!disabled) {
          onClick()
        }
      }}
      id={domId}
      className={Classnames(
        'rounded relative w-full md:w-auto font-bold items-center group cursor-pointer transition shadow-sm hover:shadow-md',
        className,
        {
          'py-3 px-5': !size,
          'text-sm py-2 px-4': size == 'sm',
          'text-xl py-3 px-5': size == 'lg',
          'font-medium py-4 px-6': size == 'input',
          'bg-white hover:bg-brand-dark-gray hover:text-white': !theme,
          'bg-white ring ring-transparent ring-offset-1 ring-offset-gray-400 hover:ring-offset-gray-700 hover:bg-brand-dark-gray hover:text-white':
            theme == 'border',
          'bg-brand-dark-gray text-white': theme == 'dark',
          'bg-gray-100 bg-opacity-10 hover:bg-black text-white':
            theme == 'light-gray',
          'bg-gray-50 hover:bg-gray-100 text-gray-800 ': theme == 'gray',
          'bg-brand-yellow text-yellow-900 hover:bg-yellow-400':
            theme == 'yellow',
          'bg-brand-blue text-white hover:bg-blue-500': theme == 'blue',
          'bg-green-500 text-white hover:bg-green-600': theme == 'green',
          'bg-purple-500 text-white hover:bg-purple-600': theme == 'purple',
          'bg-red-500 text-white hover:bg-red-600': theme == 'red',
          'border-2 border-red-500 text-red-500 hover:text-white hover:bg-red-500':
            theme == 'delete',
          'text-gray-500 opacity-70 cursor-not-allowed': disabled,
          'cursor-wait': isLoading,
          'inline-flex': !block,
          'flex text-center w-full': block,
        }
      )}
    >
      {icon && (
        <div
          className={Classnames('text-xl', {
            'mr-2 -ml-1': text,
            'text-sm': size == 'sm',
            'text-3xl': size == 'lg',
            'opacity-0': isLoading,
          })}
        >
          {icon}
        </div>
      )}
      {text && (
        <div
          className={Classnames({
            'opacity-0': isLoading,
            ' text-center w-full': block,
          })}
        >
          {text}
        </div>
      )}

      {isLoading && (
        <div className="absolute w-full h-full top-0 left-0 flex items-center justify-center">
          {!theme && (
            <Spinner size="25px" color="#000" className="opacity-60" />
          )}

          {theme && <Spinner size="25px" color="#FFF" className="opacity-80" />}
        </div>
      )}
    </div>
  )
}

export default Button
